import React from "react";
import InvoiceContainer from "./invoice/InvoiceContainer";
import EditPreliquidationAmountContainer from "./editPreliquidationAmount/EditPreliquidationAmountContainer";
import "./wrapperPreliquidation.scss";

import DetailPreliquidationContainer from "./preliquidation/DetailPreliquidationContainer";
import {
  PagesPreliquidationTypes,
  WrapperPreliquidationPropsType,
} from "./types";
import RejectInvoiceContainer from "./rejectInvoice/RejectInvoiceContainer";
import { HeaderDescription, Paginator, Tabs } from "@pickit/pickit-components";
import { AlignTypes } from "@pickit/pickit-components/dist/Tabs/types";
import Back from "component/back/Back";
import { useTranslation } from "react-i18next";

const tabIds: PagesPreliquidationTypes[] = ["preliquidation", "invoice"];

export const WrapperPreliquidation: React.FC<
  WrapperPreliquidationPropsType
> = ({
  actualPage,
  showModal,
  currentInvoice,
  invoicesIds,
  isBulkFlow,
  onPageClick,
  changePage,
  handleClickBack,
  preliquidation,
}): JSX.Element => {
  const { t } = useTranslation();
  return (
    <>
    <div className="header-container-wrapper">
        <HeaderDescription
          headline={`Preliquidación N° ${preliquidation?.id}`}
          overline={`Administración - Preliquidaciones`}
          testId="wrapper-presettlement-title"
        />
        <Back
          testId="wrapper-preliquidation-button-back"
          id="wrapper-preliquidation-button-back"
          onClick={handleClickBack}
        />
        </div>
        <div className="header-container">
        <Tabs
          tabs={[
            { title: t("detailPresettlement:presettlement"), icon: "calendar", testId: "detail-preliquidations-tab-presettlement" },
            { title: t("detailPresettlement:invoice"), icon: "document", testId: "detail-preliquidations-tab-invoice" },
          ]}
          initialIndex={tabIds.indexOf(actualPage)}
          onChange={(action, index) => {
            action();
            changePage(tabIds[index ?? 0]);
          }}
          align={"left" as AlignTypes}
          size="large"
          width="25%"
        >
          <>
            <>
              <DetailPreliquidationContainer testId="detail-preliquidation" />
            </>
            <>
              <InvoiceContainer />
            </>
          </>
        </Tabs>
        </div>
      {isBulkFlow && (
        <div className="paginator-container">
          <Paginator
            currentPage={currentInvoice}
            totalPages={invoicesIds?.length}
            onPageClick={onPageClick}
          />
        </div>
      )}
      <EditPreliquidationAmountContainer />
      <RejectInvoiceContainer isOpen={showModal} />
    </>
  );
};
